module.exports = __webpack_public_path__ + "img/orange_090.00645bd3.png";